import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { RoutingProvider, createRoutingStrategy } from '@rad/hooks';
import NotImplementedProvider from '@rad/components/utility/not-implemented-context';
import { ContextAuth } from './hooks/useAuth';
import { configurePathToURL } from './common/routes/urls/_';
import { ToastProvider } from './contexts/toast';
import PublicNav from './screens/landing-site/components/public-nav';
import Footer from './screens/landing-site/components/footer';
import { useAuthHelper } from './_common';
const AuthBootstrap = (props) => {
    const [stateAuth, setToken, setContext] = useAuthHelper();
    return (_jsx(ContextAuth.Provider, { value: { 'state': stateAuth, setToken, setContext }, children: props.children }));
};
const routingStrategy = createRoutingStrategy(__ROUTING_BASENAME__);
configurePathToURL(routingStrategy);
const Header = () => (_jsx(RoutingProvider, { strategy: routingStrategy, children: _jsx(ToastProvider, { children: _jsx(NotImplementedProvider, { children: _jsx(AuthBootstrap, { children: _jsx(PublicNav, {}) }) }) }) }));
export { Header, Footer };
